export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.svg?e33e2cf6e02cac2ccb77689015f11c56";